import relatorioConsumoFinanceiro from './relatorioConsumoFinanceiro'
import relatorioEntrada from './relatorioEntrada'
import motivoBaixa from './motivoBaixa'
import entrada from './entrada'
import saida from './saida'
import baixa from './baixa'
import inventario from './inventario'
import entradaInicial from './entradaInicial'
import balancete from './balancete'
import parametrizacao from './parametrizacao'
import requisicaoAberturaFechamento from './requisicaoAberturaFechamento'
import requisicaoPendentePermissao from './requisicaoPendentePermissao'
import transferencia from './transferencia'
import relatorioEstornoEntrada from './relatorioEstornoEntrada'
import relatorioEstornoSaida from './relatorioEstornoSaida'
import relatorioValidadeMaterial from './relatorioValidadeMaterial'
import relatorioSaida from './relatorioSaida'
import relatorioPosicaoEstoque from './relatorioPosicaoEstoque'
import relatorioRequisicao from './relatorioRequisicao'
import relatorioConsumoMedioMensal from './relatorioConsumoMedioMensal'
import dispensacaoMateriais from './dispensacaoMateriais'

export default [
    {
        path: 'almoxarifado',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...relatorioConsumoFinanceiro,
            ...relatorioEntrada,
            ...motivoBaixa,
            ...entrada,
            ...saida,
            ...baixa,
            ...inventario,
            ...entradaInicial,
            ...balancete,
            ...parametrizacao,
            ...requisicaoAberturaFechamento,
            ...requisicaoPendentePermissao,
            ...transferencia,
            ...relatorioEstornoEntrada,
            ...relatorioEstornoSaida,
            ...relatorioValidadeMaterial,
            ...relatorioSaida,
            ...relatorioPosicaoEstoque,
            ...relatorioRequisicao,
            ...relatorioConsumoMedioMensal,
            ...dispensacaoMateriais,
        ]
    }
]